import { render, staticRenderFns } from "./ReportDesktopGroupReserved.vue?vue&type=template&id=4be31cda"
import script from "./ReportDesktopGroupReserved.vue?vue&type=script&lang=js"
export * from "./ReportDesktopGroupReserved.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports